"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowLayout = void 0;
var one_column_1 = require("./one-column");
var three_col_1 = require("./three-col");
var two_column_1 = require("./two-column");
exports.WorkflowLayout = {
    ThreeColumn: three_col_1.ThreeColumnLayout,
    TwoColumn: two_column_1.TwoColumnLayout,
    OneColumn: one_column_1.OneColumnLayout,
};
